import { Display } from "rot-js"
import { PlayerAction } from "../defines/enums"
import { Offset } from "../defines/types"

export abstract class Popup {
  protected _showConfirmDialog: boolean = false

  constructor(
    public width: number,
    public height: number,
    public offsets: Offset,
    public name: string
  ) {}

  abstract prepareToRender(): void
  abstract postRender(): void
  abstract render(display: Display): void
  abstract update(action: PlayerAction): void
  protected abstract initTiles(): void

  hideConfirmDialog(): void {
    this._showConfirmDialog = false
  }

  showConfirmDialog(): void {
    this._showConfirmDialog = true
  }

  showingConfirmDialog(): boolean {
    return this._showConfirmDialog
  }
}
